import { Typography } from '@mui/material';
import Grid from 'components/core/Grid';

import { TwilioVerificationChannelEnum, UserRoleIDEnum, useTwilioSendCodeMutation } from '@alluradirect/react';

import { Form, Formik } from 'formik';
import { DividerTemp } from '../../components/styles';
import { useListModalContext } from '../listModalContext';
import SelectSetupType from './SelectSetupType';
import { useListPageModalNavigation } from '../hooks/useListPageModalNavigation';
import { ListPageResortFormInputs } from './ListPageResortFormInputs';
import { ListPageUserFormInputs } from './ListPageUserFormInputs';
import * as yup from 'yup';
import { UserSignUpTermsOfService } from 'components/views/pages/signup/components/UserSignUpTermsOfService';
import { LoadingButton } from 'components/core/LoadingButton/LoadingButton';

const validationSchema = yup.object().shape({
  email: yup.string().email().min(3).max(100).required().label('Email'),
  firstName: yup.string().max(100).required().label('First Name'),
  lastName: yup.string().max(100).required().label('Last Name'),
});

export const ListUserCreateFormUnassisted = () => {
  const sendTwilioVerification = useTwilioSendCodeMutation();

  const { pushNextStep } = useListPageModalNavigation();

  const {
    listFormValues: { email, resort_id, firstName, lastName },
    setListFormValues,
  } = useListModalContext();

  const onSubmit = (value: any) => {
    setListFormValues({
      email: value.email,
      resort_id: value.resortId,
      firstName: value.firstName,
      lastName: value.lastName,
      // Listing URL is blank for the Unassisted Form
      listingUrl: '',
    });

    sendTwilioVerification.mutate(
      { value: value.email, channel: TwilioVerificationChannelEnum.email },
      { onSuccess: pushNextStep },
    );
  };

  const initialValues = {
    email,
    firstName,
    lastName,
    resortId: resort_id,
    isOtherResortSelected: false,
    is_email_taken: false,
  };

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <SelectSetupType />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h5" mb={2}>
          Where is the Property Located?
        </Typography>
        <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={validationSchema}>
          {({ values }) => (
            <Form>
              <ListPageResortFormInputs />
              <DividerTemp my={3} />
              <Typography variant="h5" mb={2}>
                Who is the Property Host?
              </Typography>

              <Grid container spacing={2}>
                <ListPageUserFormInputs />
                <Grid item xs={12}></Grid>
                <Grid item xs={12}>
                  <LoadingButton
                    isFormikButton
                    isFullWidth
                    buttonColor="secondary"
                    variant="contained"
                    size="large"
                    isLoading={sendTwilioVerification.isLoading}
                    isDisabled={values.is_email_taken}
                  >
                    Continue
                  </LoadingButton>
                </Grid>
                <Grid item xs={12}>
                  <UserSignUpTermsOfService userTypeId={UserRoleIDEnum.owner} />
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Grid>
    </Grid>
  );
};
